import { takeEvery, put, select, all } from 'redux-saga/effects';
import { toastr } from 'react-redux-toastr';

import * as types from '../../actions/candidate/candidate-application-draft/types';
import * as actions from '../../actions/candidate/candidate-application-draft';
import { fetchApplicationSummaryById } from '../../actions/candidate/candidate-application';

import applicationStatuses from '../../constants/application-statuses';

import apiFetcher from '../../tools/api-fetcher';
import handleError from '../../tools/error-helper';

function* fetchApplicationDraftState({ applicationId }) {
  yield put(actions.setApplicationDraftLoading(true));

  try {
    const { data } = yield apiFetcher
      .auth()
      .get(`/candidates/current/applications/incomplete/${applicationId}/state`);

    yield put(actions.setApplicationDraftState(data));
  } catch (exception) {
    handleError(exception);
  }

  yield put(actions.setApplicationDraftLoading(false));
}

function* submitApplicationDraft({ applicationId }) {
  yield put(actions.setApplicationSubmitting(true));

  try {
    yield apiFetcher
      .auth()
      .post(`candidates/current/applications/submit`, { applicationId });

    yield put(actions.setApplicationHasBeenSubmitted(true));

    yield toastr.success('Application was successfully submitted.');
  } catch (exception) {
    handleError(exception, 'Failed to submit application');

    yield fetchApplicationDraftState({ applicationId });
  }

  yield put(actions.setApplicationSubmitting(false));
}

function* deleteApplicationDraft({ applicationId }) {
  yield put(actions.setApplicationCanceling(true));

  try {
    yield apiFetcher
      .auth()
      .delete(`candidates/current/applications/incomplete/${applicationId}`);

    yield put(actions.setApplicationHasBeenCanceled(true));
  } catch (exception) {
    handleError(exception);
  }

  yield put(actions.setApplicationCanceling(false));
}

function* updateCandidateApplicationCoverLetter({
  applicationId,
  applicationCoverLetter
}) {
  yield put(actions.setCandidateApplicationCoverLetterUpdating(true));

  try {
    yield apiFetcher
      .auth()
      .put(
        `/candidates/current/applications/${applicationId}/cover-letter`,
        applicationCoverLetter
      );

    yield put(actions.fetchApplicationDraftState(applicationId));
  } catch (exception) {
    handleError(exception);
  }

  yield put(actions.setCandidateApplicationCoverLetterUpdating(false));
}

function* updateCandidateApplicationSupplementaryQuestions({
  applicationId,
  applicationSupplementaryQuestions
}) {
  yield put(
    actions.setCandidateApplicationSupplementaryQuestionsUpdating(true)
  );

  try {
    yield apiFetcher
      .auth()
      .put(
        `/candidates/current/applications/${applicationId}/supplementary-questions`,
        applicationSupplementaryQuestions
      );

    const candidateApplication = yield select(
      state => state.candidateApplication
    );
    const applicationSummary = candidateApplication.get('applicationSummary');

    if (applicationSummary.status !== applicationStatuses.incomplete) {
      yield put(fetchApplicationSummaryById(applicationId));
    } else {
      yield put(actions.fetchApplicationDraftState(applicationId));
    }
  } catch (exception) {
    handleError(exception);
  }

  yield put(
    actions.setCandidateApplicationSupplementaryQuestionsUpdating(false)
  );
}

function* updateCandidateApplicationSupplementaryQuestionsAnswers({
  applicationId,
  applicationSupplementaryQuestionsAnswers
}) {
  yield put(
    actions.setCandidateApplicationSupplementaryQuestionsUpdating(true)
  );

  try {
    yield apiFetcher
      .auth()
      .put(
        `/candidates/current/applications/${applicationId}/supplementary-questions/answers`,
        applicationSupplementaryQuestionsAnswers
      );

    const candidateApplication = yield select(
      state => state.candidateApplication
    );
    const applicationSummary = candidateApplication.get('applicationSummary');

    if (applicationSummary.status !== applicationStatuses.incomplete) {
      yield put(fetchApplicationSummaryById(applicationId));
    } else {
      yield put(actions.fetchApplicationDraftState(applicationId));
    }
  } catch (exception) {
    handleError(exception);
  }

  yield put(
    actions.setCandidateApplicationSupplementaryQuestionsUpdating(false)
  );
}

export default function* applicationDraftSaga() {
  yield all([
    takeEvery(
      types.CANDIDATE_APPLICATION_DRAFT_FETCH_APPLICATION_DRAFT_STATE,
      fetchApplicationDraftState
    ),
    takeEvery(
      types.CANDIDATE_APPLICATION_DRAFT_DELETE_APPLICATION_DRAFT,
      deleteApplicationDraft
    ),
    takeEvery(
      types.CANDIDATE_APPLICATION_UPDATE_COVER_LETTER,
      updateCandidateApplicationCoverLetter
    ),
    takeEvery(
      types.CANDIDATE_APPLICATION_DRAFT_SUBMIT_APPLICATION_DRAFT,
      submitApplicationDraft
    ),
    takeEvery(
      types.CANDIDATE_APPLICATION_UPDATE_SUPPLEMENTARY_QUESTIONS,
      updateCandidateApplicationSupplementaryQuestions
    ),
    takeEvery(
      types.CANDIDATE_APPLICATION_UPDATE_SUPPLEMENTARY_QUESTIONS_ANSWERS,
      updateCandidateApplicationSupplementaryQuestionsAnswers
    )
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/candidate/candidate-application-draft.js